import { useRef } from "react";

/** A drawer's words, kept steady while it animates closed: the value while `open`, else the last one shown. */
export function useLatched<T>(open: boolean, value: T): T {
  const last = useRef(value);
  if (open) last.current = value;
  return last.current;
}
